import React, { useEffect, useState } from 'react';
import { Card, Table, Tag, Progress, Row, Col, Statistic } from 'antd';
import { BookOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import api from '../../api/axios';

const StudentProgressTab = ({ studentId }) => {
  const [projects, setProjects] = useState([]);
  const [progress, setProgress] = useState([]);
  const [dailyWorkNotes, setDailyWorkNotes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!studentId) return;
    setLoading(true);
    api.get(`/students/${studentId}/projects`)
      .then(res => {
        setProjects(res.data?.projects || []);
        setProgress(res.data?.progress || []);
        setDailyWorkNotes(res.data?.daily_work_notes || []);
      })
      .catch(() => { setProjects([]); setProgress([]); setDailyWorkNotes([]); })
      .finally(() => setLoading(false));
  }, [studentId]);

  const dailyWorkNoteColumns = [
    {
      title: 'Tarih',
      key: 'date',
      render: (_, r) => r.lesson_session?.date
        ? dayjs(r.lesson_session.date).format('DD.MM.YYYY')
        : '—',
      sorter: (a, b) => dayjs(a.lesson_session?.date).unix() - dayjs(b.lesson_session?.date).unix(),
      defaultSortOrder: 'descend',
    },
    {
      title: 'Derslik',
      key: 'classroom',
      render: (_, r) => r.lesson_session?.classroom?.name || '—',
    },
    {
      title: 'Sertifika Programı',
      key: 'course',
      render: (_, r) => r.course?.name
        ? <Tag color="blue">{r.course.name}</Tag>
        : '—',
    },
    {
      title: 'Bugünkü Çalışma',
      key: 'note',
      render: (_, r) => r.note || '—',
    },
  ];

  const columns = [
    {
      title: 'Tarih',
      key: 'date',
      render: (_, r) => r.lesson_session?.date
        ? dayjs(r.lesson_session.date).format('DD.MM.YYYY')
        : '—',
      sorter: (a, b) => dayjs(a.lesson_session?.date).unix() - dayjs(b.lesson_session?.date).unix(),
      defaultSortOrder: 'descend',
    },
    {
      title: 'Saat',
      key: 'time',
      render: (_, r) => r.lesson_session?.start_time
        ? r.lesson_session.start_time.slice(0, 5)
        : '—',
    },
    {
      title: 'Derslik',
      key: 'classroom',
      render: (_, r) => r.lesson_session?.classroom?.name || '—',
    },
    {
      title: 'Sertifika Programı',
      key: 'course',
      // Yarışma çalışmasında sertifika programı ve konu YOK — etiketlenmezse
      // satır iki tane "—" olarak görünür ve yönetici o dersin ne olduğunu
      // anlayamaz.
      render: (_, r) => r.type === 'competition'
        ? <Tag color="purple">Yarışma Çalışması</Tag>
        : (r.course?.name ? <Tag color="blue">{r.course.name}</Tag> : '—'),
    },
    {
      title: 'Konu',
      key: 'topic',
      render: (_, r) => (r.type === 'competition' ? '—' : (r.topic?.name || '—')),
    },
  ];

  return (
    <>
      {progress.length > 0 && (
        <Card
          title={
            <span className="flex items-center gap-2">
              <BookOutlined />
              Sertifika Programı İlerlemesi
            </span>
          }
          style={{ marginBottom: 16 }}
        >
          <Row gutter={[24, 16]}>
            {progress.map(p => {
              const pct = p.total > 0 ? Math.round((p.completed / p.total) * 100) : 0;
              return (
                <Col key={p.course_id} xs={24} sm={12} md={8}>
                  <div style={{ marginBottom: 4 }}>
                    <Tag color="blue" style={{ marginBottom: 6 }}>{p.course_name}</Tag>
                  </div>
                  <Progress
                    percent={pct}
                    format={() => `${p.completed}/${p.total} konu`}
                    status={pct === 100 ? 'success' : 'active'}
                    strokeColor={pct === 100 ? '#52c41a' : '#1677ff'}
                  />
                </Col>
              );
            })}
          </Row>
        </Card>
      )}
      <Card
        title={
          <span className="flex items-center gap-2">
            <BookOutlined />
            Proje Geçmişi
          </span>
        }
        style={{ marginBottom: 16 }}
      >
        <Table
          size="small"
          rowKey="id"
          dataSource={projects}
          columns={columns}
          loading={loading}
          pagination={{ pageSize: 20, hideOnSinglePage: true }}
          locale={{ emptyText: 'Henüz proje kaydı yok.' }}
        />
      </Card>
      <Card
        title={
          <span className="flex items-center gap-2">
            <BookOutlined />
            Bugünkü Çalışma Geçmişi
          </span>
        }
      >
        <Table
          size="small"
          rowKey="id"
          dataSource={dailyWorkNotes}
          columns={dailyWorkNoteColumns}
          loading={loading}
          pagination={{ pageSize: 20, hideOnSinglePage: true }}
          locale={{ emptyText: 'Henüz bugünkü çalışma notu yok.' }}
        />
      </Card>
    </>
  );
};

export default StudentProgressTab;
